// src/api/adminSettingsApi.ts
import axios from "axios";

const API_URL = "https://api.thunderbirdsmoke.net/api/admin/app-settings";

const authHeader = () => {
  const token = localStorage.getItem("authToken") || localStorage.getItem("token"); // ✅ check both
  if (!token) throw new Error("No auth token found");
  return { Authorization: `Bearer ${token}` };
};

export const getAppSettings = async () => {
  const res = await axios.get(API_URL, { headers: authHeader() });
  return res.data;
};

export const updateAppSettings = async (settings: {
  local_delivery_enabled?: boolean;
  default_delivery_fee_cents?: number;
  use_zones_for_delivery?: boolean;
  delivery_eta_start?: string;
  delivery_eta_end?: string;
}) => {
  const res = await axios.put(API_URL, settings, { headers: authHeader() });
  return res.data;
};
